import StatusIcon from "../../../../../../parts/StatusIcon";
import { ActionsButtons } from "./ActionsButtons";

const autoGrow = (el) => {
  if (!el) return;
  el.style.height = "auto";
  el.style.height = `${el.scrollHeight}px`;
};

const Assistant = ({
  finalSets,
  editDayMode,
  editable,
  hasActuals = false,
  exerciseId,
  handleInput,
  addTempSet,
  removeSet,
  removeTempSet,
}) => (
  <div
    className={`assistant-container${
      editDayMode && !editable ? " not-editable" : ""
    }`}
  >
    {finalSets?.map((set, idx) => {
      const isTemp = set.temp === true;
      // Free-form sets carry a single outcome at index 0.
      const entry = hasActuals ? set.outcomes?.[0] : null;
      const status = entry?.status;
      return (
        <div className="set-row" key={idx}>
          {editDayMode && editable ? (
            <>
              <textarea
                id={`sets-${exerciseId}-${idx}`}
                ref={autoGrow}
                value={set.freeform}
                onChange={(evt) => {
                  autoGrow(evt.target);
                  handleInput({
                    value: evt.target.value,
                    field: "freeform",
                    exerciseId,
                    setIdx: idx,
                  });
                }}
                className="resize-y"
              />
              <ActionsButtons
                isTemp={isTemp}
                onAddSet={() =>
                  addTempSet({ exerciseId, pos: idx, freeForm: true })
                }
                addSetImgSize={24}
                onRemoveSet={() => removeSet(exerciseId, idx)}
                removeSetImgSize={18}
                onDiscardSet={() => removeTempSet(exerciseId, idx)}
              />
            </>
          ) : status ? (
            <span className={status === "completed" ? "ok" : "missed"}>
              <span className="wk-status-inline">
                <StatusIcon status={status} />
              </span>
              {entry.outcome?.freeform || set.freeform}
            </span>
          ) : (
            set.freeform
          )}
        </div>
      );
    })}
  </div>
);

export default Assistant;
